import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Locations from "./pages/locations/locations";
import ProtectedRoute from "./components/ProtectedRoute";
import Location from "./pages/location/location";
import Bookmark from "./pages/bookmark/bookmark";
import Log from "./pages/log/log";

import NewSpace from "./pages/newSpace/newSpace";
import NewFloor from "./pages/newFloor.tsx/newFloor";
import EditSpace from "./components/EditSpace";
import EditFloor from "./components/EditFloor";
import Reports from "./pages/Reports/reports";
import ReportsNew from "./pages/Reports/reports-new";
import Settings from "./pages/settings/Settings";
import Alerts from "./pages/Alerts";
import Users from "./pages/users/users";

import Tv from "./components/tv/Tv";
import TvTitle from "./components/tv/TvTitle";
import TvLengends from "./components/tv/TvLegends";
import TvTitleAndLegends from "./components/tv/TvTitleAndLegends";
import NewTvTitleAndLegends from "./components/tv/NewTvTitleAndLegends";
import NewTvTitleAndLegendsWider from "./components/tv/NewTvTitleAndLegendsWider";
import TvTitleAndLegendsZoom from "./components/tv/TvTitleAndLegendsZoon";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/TV/:GrpId/:id" element={<Tv />} />
        <Route path="/TV-Title/:GrpId/:id" element={<TvTitle />} />
        <Route
          path="/TV-NewTitleAndLegends/:GrpId/:id"
          element={<NewTvTitleAndLegends />}
        />
        <Route
          path="/TV-NewTitleAndLegendsWider/:GrpId/:id"
          element={<NewTvTitleAndLegendsWider />}
        />
        <Route
          path="/TV-TitleAndLegendsZoom/:GrpId/:id"
          element={<TvTitleAndLegendsZoom />}
        />
        <Route path="/TV-Legends/:GrpId/:id" element={<TvLengends />} />
        <Route
          path="/TV-TitleAndLegends/:GrpId/:id"
          element={<TvTitleAndLegends />}
        />
        <Route path="*" element={<div>not found</div>}></Route>
        <Route path="/" element={<ProtectedRoute />}>
          <Route index element={<Locations />} />
          <Route path="/log" element={<Log />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports-new" element={<ReportsNew />} />
          <Route path="/:id/presentation" element={<Location />} />
          <Route path="/:id" element={<Location />} />
          <Route path="/Location/:GrpId/:id" element={<Location />} />
          <Route path="/Location/:GrpId" element={<Locations />} />
          <Route path="/bookmarks" element={<Bookmark />} />
          <Route path="/newSpace" element={<NewSpace />} />
          <Route path="newFloor/:id" element={<NewFloor />} />
          <Route path="/editSpace/:id" element={<EditSpace />} />
          <Route path="/editFloor/:GrpId/:id" element={<EditFloor />} />
          <Route path="/users" element={<Users />} />
          <Route path="/alerts" element={<Alerts />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
